export const requiredFields = [
	{ key: 'firstName', message: 'Please enter your First Name' },
	{ key: 'lastName', message: 'Please enter your Last Name' },
	{ key: 'emailAddress', message: 'Please enter an Email Address' },
];
